import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular/lazy';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login.component';
import { LayoutModule } from '@app/layout/layout.module';
import { SharedModule } from '@app/shared/shared.module';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { SmartMovingSharedLibModule } from '@smartmoving/sm-shared-lib';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AuthRouteGuard } from '@app/auth-route-guard.service';
import { CoreModule } from '@app/core/core.module';
import { BiometricPermissionModalComponent } from '@pages/login/biometric-permission-modal/biometric-permission-modal.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AuthRouteGuard]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    CoreModule,
    LayoutModule,
    SharedModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    SmartMovingSharedLibModule
  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.reCaptchaSiteKey,
      } as RecaptchaSettings,
    },
  ],
  declarations: [LoginComponent, ForgotPasswordComponent, ResetPasswordComponent, BiometricPermissionModalComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class LoginModule {
}
